__turbopack_context__.v({
  "actions": "SocialShare-module__hJMtYG__actions",
  "article": "SocialShare-module__hJMtYG__article",
  "channelLink": "SocialShare-module__hJMtYG__channelLink",
  "copyButton": "SocialShare-module__hJMtYG__copyButton",
  "copyButtonText": "SocialShare-module__hJMtYG__copyButtonText",
  "heading": "SocialShare-module__hJMtYG__heading",
  "socialShare": "SocialShare-module__hJMtYG__socialShare",
});
